import { UserRequestManagingUserIconConfig } from "../interface/user-request-managing-user-icon-config.model";

export const DEFAULT_USER_REQUEST_MANAGING_USER_ICON_CONFIG: UserRequestManagingUserIconConfig = {
    popoverType: 'managingUser'
}